import { homeEquityLoanTypes } from "shared_critical/format_helper";

MOVE.MORTGAGE.RATES.REQUESTS = (function() {

  var getAnalysis = function (args, callback) {
    var options = {
      location: args.location || MOVE.MORTGAGE.getQueryValue('location') || MOVE.MORTGAGE.getQueryValue('zip'),
      recent_location: args.recent_location || MOVE.MORTGAGE.getSearchLocation(),
      property_price: args.property_price ,
      mprid: args.mprid || MOVE.MORTGAGE.getQueryValue('mprid'),
      mlid: args.mlid || MOVE.MORTGAGE.getQueryValue('mlid'),
      include_marketing_summary: true
    };

    $.ajax({
      url: '/mrtg_handler/rates/analysis',
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(options),
      success: function (data) {
        if (data.meta.success && data.analysis) {
          callback(data);
        } else {
          MOVE.Common.addNewRelicLog('RateTableAnalysisErrors', data.meta.errors);
        }
      },
      error: function (data, err) {
        MOVE.Common.addNewRelicLog('RateTableAnalysisError', err);
      }
    });
  };

  var getRateTable = function (args) {
    var loan_types = _.reject(args.loan_types, function(lt) {
      return lt == 'All'
    });

    var options = {
      zip: args.zip,
      property_price: args.property_price,
      loan_purpose: args.loan_purpose,
      loan_types: loan_types.join(','),
      pts: args.pts,
      ltv: args.ltv || 80,
      credit_score: args.credit_score,
      client: 'new_rate_table'
    };

    if (args.provider) options.provider = args.provider;
    if (MOVE_DATA.reference) options.reference = encodeURIComponent(
      MOVE_DATA.reference.replace(/[^\w]*/g, '')
    );

    $.ajax({
      url: '/mrtg_handler/rates/get_rates_table',
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(options),
      success: function (data) {
        if (data.meta.success) {
          if (args.success) { args.success(data); }
        } else {
          if (args.error) { args.error(data); }
          MOVE.MORTGAGE.RATES.SEARCH_VIEW.actions
            .displayRatesSearchError();
          MOVE.Common.addNewRelicLog('RateTableRequestErrors', data.meta.errors);
        }
      },
      error: function (data, err) {
        if (args.error) { args.error(data, err); }
        MOVE.Common.addNewRelicLog('RateTableRequestError', err);
      }
    });
  };

  var getHelocRateTable = function(args) {
    const selectedLoans = args.search.loan_product.split(',');
    const allLoansValue = homeEquityLoanTypes[0].value;
    const allLoanTypes = homeEquityLoanTypes.slice(1).map((type) => type.value);
    if (_.isEmpty(_.difference(allLoanTypes, selectedLoans))) {
      args.search.loan_product = allLoansValue
    }
    const str = $.param(args.search);

    $.ajax({
      url: '/mrtg_handler/rates/get_heloc_rates_table?' + str,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (data) => {
        if (data.meta && data.meta.count > 0) {
          if (args.success) { args.success(data); }
        } else {
          if (args.error) { args.error(data); }
        }
      },
      error: (data, error) => {
        if (args.error) { args.error(data, error); }
      }
    })
  }

  MOVE.MORTGAGE.RATES.REQUESTS = {
    getAnalysis: getAnalysis,
    getRateTable: getRateTable,
    getHelocRateTable: getHelocRateTable
  };

  return MOVE.MORTGAGE.RATES.REQUESTS;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/actions/requests.js